<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-table">
				<table class="qms-table">
					<tbody>
						<tr>
							<th></th>
							<th v-for="(item, idx) in graphList" :key="idx">{{ item.calYyyy + '/' + item.calMm }}</th>
							<!-- 합계 -->
							<th>{{ getMessage_('QWCC001425') }}</th>
						</tr>
						<tr>
							<!-- 계획 -->
							<th>{{ getMessage_('QWCC001661') }}</th>
							<td v-for="(item, idx) in graphList" :key="idx">
								{{ item.planCnt }}
							</td>
							<td>{{ getPlanSum }}</td>
						</tr>
						<tr>
							<!-- 실적 -->
							<th>{{ getMessage_('QWCC001450') }}</th>
							<td v-for="(item, idx) in graphList" :key="idx">
								{{ item.resultCnt }}
							</td>
							<td>{{ getResultSum }}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	methods: {
		...rootMethods,
		...serviceMethods
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		getPlanSum() {
			let cnt = 0;
			for (const item of this.graphList) {
				cnt += Number(item.planCnt);
			}
			return cnt;
		},
		getResultSum() {
			let cnt = 0;
			for (const item of this.graphList) {
				cnt += Number(item.resultCnt);
			}
			return cnt;
		}
	}
};
</script>

<style lang="scss" scoped></style>
